import React, { useRef, useState } from 'react';
import Nouislider from "nouislider-react";
import 'nouislider/distribute/nouislider.css';
import { Label } from "reactstrap";

function FallbackRange({ fallback = [], setFallback = () => { } }) {
  const [addedImages, setAddedImages] = useState([]);
  const [thumbPosition, setThumbPosition] = useState(0);
  const rangeRef = useRef(null);

  function handleThumbPositionChange() {
    if (rangeRef.current) {

      // const thumb = rangeRef.current.querySelector('.noUi-origin .noUi-handle').getAttribute("aria-valuenow");
      // if (thumb) {
      //   setThumbPosition(thumb);
      // }
    }
  }

  function addImage(e) {
    const file = e.target.files[0];
    setFallback(([...fallback, file]));
  }

  return (
    <div className='w-100 d-flex flex-nowrap align-items-center'>
      <div className='custom-range-select me-2' ref={rangeRef}>
        {fallback.map((item, idx) => {
          return (
            <div className='range-image-label' key={idx}>
              <i className='mdi mdi-image-multiple'></i>
            </div>
          )
        })}
        <Nouislider
          range={{ min: 0, max: 100 }}
          start={[0]}
          connect
          onSlide={handleThumbPositionChange}
        />
      </div>
      <input type='file' id='file' className='d-none' onChange={addImage}></input>
      <Label className="btn btn-icon btn-light text-muted" htmlFor="file">
        <i className='mdi mdi-plus-box-multiple'></i>
      </Label>
    </div>
  )
}

export default FallbackRange